
<template>

  <div class="body">

    <v-card class="card-container" style="text-align:left">
      <v-container class="license-container">
        <v-layout justify-center row wrap>
          <v-flex style="max-width: 1100px;">
            <div class="page-header">
              <h1>STMicroelectronics Cloud Applications and Dashboards Terms of Use</h1>
              <v-spacer></v-spacer>
              <a @click="accept()" class="btn btn-accept" style="float:right;margin-top:-50px">ACCEPT</a>
            </div>
            <div class="agreement-copy">
              <section id="section_qsk_nv3_qs">
                <p>These terms of use contain the terms and conditions that govern your access to and use of the Cloud Applications and
Dashboards (as defined below) and is an agreement between STMicroelectronics International N.V., a company incorporated
under the laws of the Netherlands, having its registered offices at WTC Schiphol Airport, Schiphol boulevard 265, 1118 BH

Luchthaven Schiphol, Amsterdam, The Netherlands, acting through its Swiss branch at 39, Chemin du Champ-des-Filles, CH-
1228 Geneva – Plan-Les-Ouates, Switzerland (also referred to as “ST,” “we,” “us,” or “our”) and you or the entity you represent

(“you” or “your”) (the “Agreement”). This Agreement takes effect when you click on “I Accept” button (the “Effective Date”). You
represent to us that you are lawfully able to enter into contracts (e.g., you are not a minor). If you are entering into this
Agreement for an entity, such as the company you work for, you represent to us that you have legal authority to bind that entity.
Please see Section 1 for definitions of certain capitalized terms used in this Agreement.</p>
              </section>
              <section>
                <span style="font-weight: bold; color: #002052">1. Definitions</span>
                <ol>
                  <li>
                    <p>
“Cloud Applications and Dashboards” means the ST cloud-based platforms and device management back-end and
front-end dashboards.
                    </p>
                  </li>
                  <li>
                    <p>
“Data” means the data collected through Evaluation Board including, as applicable, motion, environmental,
ultrasound and/or other data as enabled in the Evaluation Board.
                    </p>
                  </li>
                  <li>
                    <p>
“Evaluation Board” has the meaning to be used only to offer limited features for evaluating ST chips. It has not been
tested for use with other products and is not suitable for any safety or other commercial or consumer application.
                    </p>
                  </li>
                  <li>
                    <p>
“ST Confidential Information” means all nonpublic information disclosed by us, our affiliates, business partners or our
or their respective employees, contractors or agents that is designated as confidential or that, given the nature of the
information or circumstances surrounding its disclosure, reasonably should be understood to be confidential. ST
Confidential Information includes: (a) nonpublic information relating to our or our affiliates or business partners’
technology, customers, business plans, promotional and marketing activities, finances and other business affairs; (b)
third-party information that we are obligated to keep confidential; and (c) the nature, content and existence of any
discussions or negotiations between you and us or our affiliates. ST Confidential Information does not include any
information that: (i) is or becomes publicly available without breach of this Agreement; (ii) can be shown by
documentation to have been known to you at the time of your receipt from us; (iii) is received from a third party who
did not acquire or disclose the same by a wrongful or tortious act; or (iv) can be shown by documentation to have
been independently developed by you without reference to the ST Confidential Information.
                    </p>
                  </li>
                </ol>
              </section>
              
              <section>
                <span style="font-weight: bold; color: #002052">2. General</span>
                <ol>
                  <li>
                    <p>
Scope of Service. The Cloud Application and Dashboard is provided to you by ST on a trial basis free of charge and
for a limited duration, as further specified in this Agreement (the “Service”). The Dashboard allows you to connect a
limited number of Evaluation Boards to a platform hosted by a third party cloud storage service provider and to store
and manage Data collected by the Evaluation Boards. Data volume limits as well as data retention time limits apply.
Please see the Dashboard related information available on www.st.com for more details on the Service limitations.
                    </p>
                  </li>
                  <li>
                    <p>
myST User Account. To access the Dashboard, you must have a myST account associated with a valid email
address.
                    </p>
                  </li>
                  <li>
                    <p>
Customer Use. The Dashboard may be used only for your internal business purposes and not for commercialization
or resale.
                    </p>
                  </li>
                  <li>
                    <p>
Term. The duration of the Agreement is one year from the effective date unless there is stated otherwise in the
Dashboard related information available on www.st.com for more details on the Service limitations. Use Restrictions.
                    </p>
                  </li>
                  <li>
                    <p>
You will use the Dashboard in accordance with STMicroelectronics Websites Terms of Use incorporated hereto by
reference, all applicable laws and regulations and, when applicable, use policies of third party cloud storage service
provider, and you will not use the Dashboard in any manner that is illegal, offensive or objectionable. ST reserves the
right to suspend your access to the Dashboard or to remove your Data if ST becomes aware of misuse of the
Dashboard.
                    </p>
                  </li>
                </ol>
              </section>


              <section>
                <span style="font-weight: bold; color: #002052">3. Security and Data Privacy</span>
                <ol>
                  <li>
                    <p>
Security. You are responsible for the use and security of any login identifiers, encryption keys, passwords or other
access controls provided to you for the use of the Cloud Application and Dashboard.
                    </p>
                  </li>
                  <li>
                    <p>
We will not access or use Data except as necessary to maintain or provide the Service to you, to monitor the use of
the Cloud Application and Dashboard and to perform aggregated data analytics in relation to the Evaluation Board
usage (for example to know which measures are most often enabled, what is the average time of data streaming, etc.), or as necessary to
comply with the law or a binding order of a governmental body. We will not disclose your Data to any government or
third party except as necessary to comply with the law or a binding order of a governmental body. Unless it would
violate the law or a binding order of a governmental body, we will give you notice of any legal requirement or order
referred to in this Section 3.b. We will only use your myST account information in accordance with our Privacy Policy.
                    </p>
                  </li>
                </ol>
              </section>


              <section>
                <span style="font-weight: bold; color: #002052">4. Proprietary Rights.</span>
                <ol>
                  <li>
                    <p>
Except as provided in this Section 4, we obtain no rights under this Agreement from you (or your licensors) to your
Data. You consent to our use of your Data to provide the Service to you under this Agreement.
                    </p>
                  </li>
                  <li>
                    <p>
b. Adequate Rights. You represent and warrant to us that: (a) you or your licensors own all right, title, and interest in and
to your Data; (b) you have all rights in the Data necessary to grant the rights contemplated by this Agreement; and (c)
none of your Data or use of your Data or the Service will violate STMicroelectronics Website Terms of Use.
                    </p>
                  </li>
                  <li>
                    <p>
Service License. Subject to the terms of this Agreement, we grant you a limited, revocable, non-exclusive, non-sub
licensable, non-transferrable license to do the following: (a) access and use the Service solely in accordance with this
Agreement; and (b) copy and use ST content solely in connection with your permitted use of the Service. Except as
provided in this Section 4.c, you obtain no rights under this Agreement from us, our affiliates or our licensors to the
Service, including any related intellectual property rights. Some ST content and third-party content may be provided
to you under a separate license, such as the Apache License, Version 2.0, or other open source license. In the event
of a conflict between this Agreement and any separate license, the separate license will prevail with respect to the ST
content or third-party content that is the subject of such separate license.
                    </p>
                  </li>
                  <li>
                    <p>
License Restrictions. You will not use the Service in any manner or for any purpose other than as expressly permitted
by this Agreement. You will not, or will not attempt to (a) access or use the Service in a way intended to exceeding
usage limits or quotas, or (b) resell or sublicense the Service. You will not imply any relationship or affiliation between
us and you except as expressly permitted by this Agreement. No right, title or interest in or to any trademark, service
mark, logo or trade name of ST or its licensors is granted under this Agreement.
                    </p>
                  </li>
                </ol>
              </section>




              <section>
                <span style="font-weight: bold; color: #002052">5. Disclaimers.</span>
                <ol>
                  <li>
                    <p>
THE SERVICE IS PROVIDED “AS IS.” EXCEPT TO THE EXTENT PROHIBITED BY LAW, OR TO THE EXTENT
ANY STATUTORY RIGHTS APPLY THAT CANNOT BE EXCLUDED, LIMITED OR WAIVED, WE AND OUR
AFFILIATES AND LICENSORS (A) MAKE NO REPRESENTATIONS OR WARRANTIES OF ANY KIND, WHETHER
EXPRESS, IMPLIED, STATUTORY OR OTHERWISE REGARDING THE SERVICE, AND (B) DISCLAIM ALL
WARRANTIES, INCLUDING ANY IMPLIED OR EXPRESS WARRANTIES (I) OF MERCHANTABILITY,
SATISFACTORY QUALITY, FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT, OR QUIET
ENJOYMENT, (II) ARISING OUT OF ANY COURSE OF DEALING OR USAGE OF TRADE, (III) THAT THE
SERVICE WILL BE UNINTERRUPTED, ERROR FREE OR FREE OF HARMFUL COMPONENTS, AND (IV) THAT
ANY CONTENT WILL BE SECURE OR NOT OTHERWISE LOST OR ALTERED.
                    </p>
                  </li>
                  <li>
                    <p>
THE SERVICE IS NOT DESIGNED FOR USE IN SAFETY CRITICAL APPLICATIONS SUCH AS LIFE
SUPPORTING DEVICES OR SYSTEMS, AND MILITARY, NUCLEAR, AUTOMOTIVE OR AEROSPACE
APPLICATIONS OR ENVIRONMENTS. ST EXPRESSLY DISCLAIMS ANY RESPONSIBILITY FOR SUCH USAGE
WHICH SHALL BE MADE AT YOUR SOLE RISK, EVEN IF ST HAS BEEN INFORMED IN WRITING OF SUCH
USAGE. YOU ACKNOWLEDGE AND AGREE TO BE SOLELY RESPONSIBLE FOR REGULATORY AND SAFETY
RELATED REQUIREMENTS CONCERNING YOUR OWN PRODUCTS AND ANY USE OF THE SERVICE.
                    </p>
                  </li>

                </ol>
              </section>


              <section>
                <span style="font-weight: bold; color: #002052">6. Limitations of Liability.</span>
                    <p>
WE AND OUR AFFILIATES AND LICENSORS WILL NOT BE LIABLE TO YOU FOR ANYDIRECT,
INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES (INCLUDING DAMAGES FOR
LOSS OF PROFITS, REVENUES, CUSTOMERS, OPPORTUNITIES, GOODWILL, USE, OR DATA), EVEN IF A PARTY
HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. FURTHER, NEITHER WE NOR ANY OF OUR
AFFILIATES OR LICENSORS WILL BE RESPONSIBLE FOR ANY COMPENSATION, REIMBURSEMENT, OR
DAMAGES ARISING IN CONNECTION WITH: (A) YOUR INABILITY TO USE THE SERVICE, INCLUDING AS A RESULT
OF ANY (I) TERMINATION OR SUSPENSION OF THIS AGREEMENT OR YOUR USE OF OR ACCESS TO THE
SERVICE, (II) OUR DISCONTINUATION OF ALL OR A PORTION OF THE SERVICE, OR, (III) ANY UNANTICIPATED
OR UNSCHEDULED DOWNTIME OF ALL OR A PORTION OF THE SERVICE FOR ANY REASON; (B) THE COST OF
PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; (C) ANY INVESTMENTS, EXPENDITURES, OR
COMMITMENTS BY YOU IN CONNECTION WITH THIS AGREEMENT OR YOUR USE OF OR ACCESS TO THE
SERVICE; OR (D) ANY UNAUTHORIZED ACCESS TO, ALTERATION OF, OR THE DELETION, DESTRUCTION,
DAMAGE, LOSS OR FAILURE TO STORE ANY OF YOUR CONTENT OR OTHER DATA. IN ANY CASE, OUR AND OUR
AFFILIATES’ AND LICENSORS’ AGGREGATE LIABILITY UNDER THIS AGREEMENT WILL NOT EXCEEDUS$100.
THE LIMITATIONS IN THIS SECTION 6 APPLY ONLY TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW
                    </p>
              </section>

              <section>
                <span style="font-weight: bold; color: #002052">7. Indemnification.</span>
                    <p>
You will defend, indemnify, and hold harmless us, our affiliates and licensors, and each of their respective
employees, officers, directors, and representatives from and against any losses arising out of or relating to any third-party
claim concerning: (a) your use of the Service (including any activities under your mySt account and use by your employees
and personnel); or (b) breach of this Agreement or violation of applicable law by you or your Data. You will reimburse us for
reasonable attorneys’ fees, as well as our employees’ and contractors’ time and materials spent responding to any third
party subpoena or other compulsory legal order or process associated with third party claims described in (a) through (b)
above at our then-current hourly rates. You will defend ST, its affiliates, and their respective employees, officers, and
directors against any third-party claim alleging that any of your Data infringes or misappropriates that third party’s
intellectual property rights, and will pay the amount of any adverse final judgment or settlement.
                    </p>
              </section>


              <section>
                <span style="font-weight: bold; color: #002052">8. Termination.</span>
                    <p>
You may terminate this Agreement at any time by notifying ST of your intention to terminate in accordance
with Section 10.h. Either party may terminate this Agreement on written notice to the other party if the other party fails to
meet any material obligation under the Agreement, and fails to remedy the breach within 30 days after being notified in
writing of the details.
                    </p>
              </section>

              <section>
                <span style="font-weight: bold; color: #002052">9. Access and Return of Data.</span>
                    <p>
During the term of this Agreement you will have access to your Data through the Dashboard
subject to the the Dashboard related information available on www.st.com for more details on the Service limitations. Upon
the termination or expiration of the Agreement, but no later than 4 weeks from expiration or termination of the Agreement,
you may request a copy of your Data. ST will provide you with a copy of Data in a format defined at its sole discretion. ST
will deliver your Data through secure FTP or other format, as available.
                    </p>
              </section>


              <section>
                <span style="font-weight: bold; color: #002052">10. Miscellaneous.</span>
                <ol>
                  <li>
                    <p>
Entire Agreement. This Agreement is the entire agreement between you and us regarding the subject matter of this
Agreement. This Agreement supersedes all prior or contemporaneous representations, understandings, agreements,
or communications between you and us, whether written or verbal, regarding the subject matter of this Agreement.
                    </p>
                  </li>
                  <li>
                    <p>
Severability. If a court or agency of competent jurisdiction holds any term of this Agreement invalid, illegal, or
unenforceable for any reason, the remainder of this Agreement shall be valid and enforceable and you and ST shall
discuss in good faith a substitute, valid, enforceable provision which most nearly effects the parties’ intent in entering
into this Agreement.
                    </p>
                  </li>
                  <li>
                    <p>
Assignment. You will not assign or otherwise transfer this Agreement or any of your rights and obligations under this
Agreement, without our prior written consent. Any assignment or transfer in violation of this Section 10.c will be void.
We may assign this Agreement without your consent (a) in connection with a merger, acquisition or sale of all or
substantially all of our assets, or (b) to any affiliate or as part of a corporate reorganization.
                    </p>
                  </li>
                  <li>
                    <p>
Force Majeure. We and our affiliates will not be liable for any delay or failure to perform any obligation under this
Agreement where the delay or failure results from any cause beyond our reasonable control, including acts of God,
labor disputes or other industrial disturbances, electrical or power outages, utilities or other telecommunications
failures, earthquake, storms or other elements of nature, blockages, embargoes, riots, acts or orders of government,
acts of terrorism, or war.
                    </p>
                  </li>
                  <li>
                    <p>
Trade Compliance. In connection with this Agreement, each party will comply with all applicable import, re-import,
sanctions, anti-boycott, export, and re-export control laws and regulations. For clarity, you are solely responsible for
compliance related to the manner in which you choose to use the Service, including your transfer and processing of
Data. You represent and warrant that you, or any party that owns or controls you, are not subject to sanctions or
otherwise designated on any list of prohibited or restricted parties, including but not limited to the lists maintained by
the United Nations Security Council, the U.S. Government (e.g., the Specially Designated Nationals List and Foreign
Sanctions Evaders List of the U.S. Department of Treasury, and the Entity List of the U.S. Department of Commerce),
the European Union or its Member States, or other applicable government authority. We may suspend or terminate
our performance under this Agreement to the extent required by applicable laws.
                    </p>
                  </li>
                  <li>
                    <p>
Independent Contractors. We and you are independent contractors, and this Agreement will not be construed to
create a partnership, joint venture, agency, or employment relationship. Neither party, nor any of their respective
affiliates, is an agent of the other for any purpose or has the authority to bind the other.
                    </p>
                  </li>
                  <li>
                    <p>
Confidentiality and Publicity. You may use ST Confidential Information only in connection with your use of the Service
as permitted under this Agreement. You will not disclose ST Confidential Information during the term of this
Agreement or at any time during the 5-year period following the end of the term. You will take all reasonable
measures to avoid disclosure, dissemination or unauthorized use of ST Confidential Information, including, at a
minimum, those measures you take to protect your own confidential information of a similar nature. You will not issue
any press release or make any other public communication with respect to this Agreement or your use of the Service.
                    </p>
                  </li>
                  <li>
                    <p><span style="font-weight: bold; color: #002052">Notice.</span></p>
                    <ol>
                      <li>
                        <p>
To You: We may provide any notice to you under this Agreement by: (i) posting a notice on the Dashboard; or (ii)
sending a message to the email address then associated with your account. Notices we provide by posting on
the Dashboard will be effective upon posting and notices we provide by email will be effective when we send the
email. It is your responsibility to keep your email address current. You will be deemed to have received any email sent to the email address then associated with your account when we send the email, whether or not you
actually receive the email.
                        </p>
                      </li>
                      <li>
                        <p>
                          To Us: To give us notice under this Agreement, you must contact ST by personal delivery, overnight courier or
registered or certified mail to the mailing address: STMicroelectronics International NV, Attn. General Counsel,
39, Chemin du Champ-des-Filles, 1228 Plan-les-Ouates, Switzerland, with a copy to: legalnotice.ch@st.com.
Such communication shall take effect upon receipt by the addressee, provided that such communication shall
be deemed to have arrived upon the expiration of seven (7) days from the date of sending in case of registered
or certified mail.
                        </p>
                      </li>
                    </ol>
                  </li>
                  <li>
                    <p>
No Waivers. The failure by ST to enforce any provisions of this Agreement or to exercise any right in respect thereto
shall not be construed as constituting a waiver of its rights thereof.
                    </p>
                  </li>
                </ol>
              </section>

              <section>
                <span style="font-weight: bold; color: #002052">11. Governing Law.</span>
                    <p>
This Agreement is governed by the laws of Switzerland, without regard to its conflict of law rules. All
disputes, differences or questions arising out of or in connection with this Agreement shall be finally settled by the
competent courts of Geneva, Switzerland. Notwithstanding the aforesaid, nothing in this Agreement shall prevent ST from
seeking any interim or final injunctive or equitable relief by a court of competent jurisdiction.
                    </p>
              </section>

              <br>
              <v-card-actions class="action-bottom">
                <a class="btn btn-decline" @click="decline() ">DECLINE</a>
                <v-spacer></v-spacer>
                <a class="btn btn-accept" @click="accept()" >ACCEPT</a>
              </v-card-actions >
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>


<script>
export default {

    name: "LicenseAgreement",
  
    methods:{
      decline: async function(){
        await 
            this
            .$store
            .dispatch('authentication/logout')
      },
      accept: async function(){
        await this.$store.dispatch('authentication/acceptLA')
        localStorage.setItem('forceRelogin','google')
        await 
            this
            .$store
            .dispatch('authentication/logout')
          
      },
    }
}
</script>